import React from "react";

const SERVICES = [
  {
    id: "neuves",
    eyebrow: "01 — Collection",
    title: "Montres",
    italic: "Neuves",
    image:
      "https://images.unsplash.com/photo-1600003014608-c2ccc1570a65?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    text:
      "Garde-temps neufs des plus grandes manufactures suisses — Patek Philippe, Rolex, Audemars Piguet et autres. Livrés scellés avec papiers et boîte d'origine, garantie maison 24 mois.",
    cta: "Demander informations",
  },
  {
    id: "occasion",
    eyebrow: "02 — Collection",
    title: "Montres",
    italic: "d'Occasion",
    image:
      "https://images.unsplash.com/photo-1730757679771-b53e798846cf?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    text:
      "Rolex, Patek et autres pièces d'exception expertisées et révisées par notre maître horloger. Authenticité garantie, état mécanique contrôlé et provenance documentée.",
    cta: "Demander informations",
  },
  {
    id: "vente",
    eyebrow: "03 — Service",
    title: "Vente &",
    italic: "Rachat",
    image:
      "https://images.unsplash.com/photo-1547996160-81dfa63595aa?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    text:
      "Nous rachetons votre montre au prix du jour — Rolex, Patek Philippe, Audemars Piguet… Estimation gratuite, confidentielle et sans engagement. Paiement comptant sous 48 heures.",
    cta: "Demander une estimation",
  },
  {
    id: "reparation",
    eyebrow: "04 — Service",
    title: "Réparation",
    italic: "horlogère",
    image:
      "https://static.prod-images.emergentagent.com/jobs/6eda8702-546d-4ee1-94a6-0616cf049749/images/171fbccfa21bc4be9cab308a01555a91175b3099181494cd03358db7b3e87902.png",
    text:
      "Révision complète, changement de pile, polissage, restauration, étanchéité — toutes interventions exécutées par notre maître horloger formé en Vallée de Joux.",
    cta: "Confier ma montre",
  },
  {
    id: "or-bijoux",
    eyebrow: "05 — Service",
    title: "Achat Or &",
    italic: "Bijoux",
    image:
      "https://images.unsplash.com/photo-1650455221359-3aebf920bcc5?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    text:
      "Achat d'or, lingots, pièces, bijoux (même cassés) et objets de valeur. Évaluation gratuite au cours du jour, paiement immédiat en toute discrétion.",
    cta: "Estimation gratuite",
  },
];

export default function Services() {
  return (
    <section
      data-testid="services-section"
      className="bg-[#F8F4EC] py-16 md:py-32"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-20">
          <p className="text-[10px] uppercase tracking-[0.4em] text-accent mb-6">
            Nos Services
          </p>
          <h2 className="font-serif font-light text-[#001226] text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight">
            Une expertise{" "}
            <span className="italic">horlogère</span>
            <br />
            à 360°.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s) => (
            <article
              key={s.id}
              id={s.id}
              data-testid={`service-${s.id}`}
              className="product-card group relative bg-white border border-[#001226]/10 hover:border-accent transition-colors duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.title} ${s.italic}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-8 md:p-10">
                <h3 className="font-serif text-3xl md:text-4xl font-light text-[#001226] leading-[1] tracking-tight">
                  {s.title} <span className="italic">{s.italic}</span>
                </h3>
                <p className="mt-5 text-[#1E2A40] font-light leading-relaxed">
                  {s.text}
                </p>
                <a
                  href={s.id === "vente" ? "#estimation" : "#contact"}
                  data-testid={`service-cta-${s.id}`}
                  className="mt-8 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] text-[#001226] border-b border-[#001226] pb-1 hover:text-accent hover:border-accent transition-colors"
                >
                  {s.cta}
                  <span aria-hidden>→</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
